<div class="modal" [class.show]="isOpen" [style.display]="isOpen ? 'block' : 'none'" tabindex="-1" role="dialog" aria-modal="true" (click)="onBackdropClick($event)">
    <div class="modal-dialog modal-dialog-centered modal-lg" (click)="$event.stopPropagation()">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{'seller_profile.edit_company_info' | translate}}</h5>
                <button type="button" class="btn-close" (click)="onClose()"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="companyForm" (ngSubmit)="onSubmit()">

                    <!-- Company Identity -->
                    <div class="mb-4">
                        <h6 class="text-primary">{{'seller_setup.company_identity' | translate}}</h6>
                        <div class="mb-3">
                            <label for="companyName">{{'seller_profile.company_name' | translate}} *</label>
                            <input
                                type="text"
                                id="companyName"
                                class="form-control"
                                [ngClass]="{ 'is-invalid': submitted && f.companyName.errors }"
                                formControlName="companyName">
                            <div *ngIf="submitted && f.companyName.errors" class="invalid-feedback">
                                {{'seller_profile.company_name_required' | translate}}
                            </div>
                        </div>
                    </div>

                    <hr>

                    <!-- Legal Information -->
                    <div class="mb-4">
                        <h6 class="text-primary">{{'seller_setup.company_legal_info' | translate}}</h6>
                        <p class="text-muted small">{{'seller_setup.optional_section_note' | translate}}</p>
                        <div class="row" formGroupName="legalInfo">
                            <div class="col-md-4 mb-3">
                                <label for="rccm">{{'seller_profile.rccm' | translate}}</label>
                                <input
                                    type="text"
                                    id="rccm"
                                    class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f['legalInfo'].get('rccm')?.errors }"
                                    formControlName="rccm">
                                <div *ngIf="submitted && f['legalInfo'].get('rccm')?.errors?.['required']" class="invalid-feedback">
                                    {{'seller_profile.rccm_required' | translate}}
                                </div>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="niu">{{'seller_profile.niu' | translate}}</label>
                                <input
                                    type="text"
                                    id="niu"
                                    class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f['legalInfo'].get('niu')?.errors }"
                                    formControlName="niu">
                                <div *ngIf="submitted && f['legalInfo'].get('niu')?.errors?.['required']" class="invalid-feedback">
                                    {{'seller_profile.niu_required' | translate}}
                                </div>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="businessLicense">{{'seller_profile.business_license' | translate}}</label>
                                <input
                                    type="text"
                                    id="businessLicense"
                                    class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f['legalInfo'].get('businessLicenseNumber')?.errors }"
                                    formControlName="businessLicenseNumber">
                                <div *ngIf="submitted && f['legalInfo'].get('businessLicenseNumber')?.errors?.['required']" class="invalid-feedback">
                                    {{'seller_profile.business_license_required' | translate}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <!-- Legal Representative -->
                    <div class="mb-4">
                        <h6 class="text-primary">{{'seller_setup.company_representative' | translate}}</h6>
                        <p class="text-muted small">{{'seller_setup.optional_section_note' | translate}}</p>
                        <div class="row" formGroupName="legalRepresentative">
                            <div class="col-md-4 mb-3">
                                <label for="repFullName">{{'seller_profile.full_name' | translate}}</label>
                                <input
                                    type="text"
                                    id="repFullName"
                                    class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f['legalRepresentative'].get('fullName')?.errors }"
                                    formControlName="fullName">
                                <div *ngIf="submitted && f['legalRepresentative'].get('fullName')?.errors?.['required']" class="invalid-feedback">
                                    {{'seller_profile.full_name_required' | translate}}
                                </div>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="repPosition">{{'seller_profile.position' | translate}}</label>
                                <input
                                    type="text"
                                    id="repPosition"
                                    class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f['legalRepresentative'].get('position')?.errors }"
                                    formControlName="position">
                                <div *ngIf="submitted && f['legalRepresentative'].get('position')?.errors?.['required']" class="invalid-feedback">
                                    {{'seller_profile.position_required' | translate}}
                                </div>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label for="repPhone">{{'common.phone' | translate}}</label>
                                <input
                                    type="text"
                                    id="repPhone"
                                    class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f['legalRepresentative'].get('phoneNumber')?.errors }"
                                    formControlName="phoneNumber"
                                    placeholder="6XXXXXXXX">
                                <div *ngIf="submitted && f['legalRepresentative'].get('phoneNumber')?.errors?.['required']" class="invalid-feedback">
                                    {{'seller_setup.phone_required' | translate}}
                                </div>
                                <div *ngIf="submitted && f['legalRepresentative'].get('phoneNumber')?.errors?.['pattern']" class="invalid-feedback">
                                    {{'seller_setup.invalid_mobile_number' | translate}}
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <!-- Operational Information -->
                    <div class="mb-4">
                        <h6 class="text-primary">{{'seller_setup.company_operational' | translate}}</h6>
                        <p class="text-muted small">{{'seller_setup.optional_section_note' | translate}}</p>
                        <div class="row" formGroupName="operationalInfo">
                            <div class="col-md-6 mb-3">
                                <label for="companyEmail">{{'seller_profile.company_email' | translate}}</label>
                                <input
                                    type="email"
                                    id="companyEmail"
                                    class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f['operationalInfo'].get('companyEmail')?.errors }"
                                    formControlName="companyEmail">
                                <div *ngIf="submitted && f['operationalInfo'].get('companyEmail')?.errors" class="invalid-feedback">
                                    {{'common.invalid_email' | translate}}
                                </div>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="companyPhone">{{'seller_profile.company_phone' | translate}}</label>
                                <input
                                    type="text"
                                    id="companyPhone"
                                    class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f['operationalInfo'].get('companyPhoneNumber')?.errors }"
                                    formControlName="companyPhoneNumber"
                                    placeholder="6XXXXXXXX">
                                <div *ngIf="submitted && f['operationalInfo'].get('companyPhoneNumber')?.errors?.['pattern']" class="invalid-feedback">
                                    {{'seller_setup.invalid_mobile_number' | translate}}
                                </div>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="country">{{'common.country' | translate}}</label>
                                <input
                                    type="text"
                                    id="country"
                                    class="form-control"
                                    formControlName="country">
                            </div>
                            <div class="col-md-6 mb-3">
                                <label for="city">{{'common.city' | translate}}</label>
                                <input
                                    type="text"
                                    id="city"
                                    class="form-control"
                                    formControlName="city">
                            </div>
                            <div class="col-12 mb-3">
                                <label for="address">{{'seller_profile.address' | translate}}</label>
                                <input
                                    type="text"
                                    id="address"
                                    class="form-control"
                                    formControlName="address">
                            </div>
                            <div class="col-12 mb-3">
                                <label for="description">{{'seller_profile.description' | translate}}</label>
                                <textarea
                                    id="description"
                                    class="form-control"
                                    formControlName="description"
                                    rows="3"></textarea>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="onClose()">
                    {{'common.cancel' | translate}}
                </button>
                <button type="button" class="btn btn-primary" (click)="onSubmit()">
                    {{'common.save' | translate}}
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show" *ngIf="isOpen" (click)="onClose()"></div>